import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import Logo from "./Logo";

const Footer = () => (
  <footer className="border-t border-[#d4af37]/15 bg-[#080809]">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <Logo size={38} wordClass="text-2xl" />
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-500">
          Imitation fine jewellery, crafted with 18k gold plating and hand-set stones.
          Heirloom looks without the heirloom price.
        </p>
        <div className="mt-6 flex gap-3">
          {[Instagram, Facebook, Youtube, Mail].map((Icon, i) => (
            <span
              key={i}
              className="p-2.5 rounded-full border border-[#d4af37]/20 text-zinc-400 hover:text-[#f3e5ab] hover:border-[#d4af37]/60 transition-all cursor-pointer"
            >
              <Icon size={16} strokeWidth={1.6} />
            </span>
          ))}
        </div>
      </div>

      <div>
        <p className="eyebrow mb-5">Explore</p>
        <ul className="space-y-3 text-sm text-zinc-400">
          <li><Link to="/shop" className="hover:text-[#f3e5ab] transition-colors" data-testid="footer-link-shop">All Jewellery</Link></li>
          <li><Link to="/shop?category=Necklaces" className="hover:text-[#f3e5ab] transition-colors" data-testid="footer-link-necklaces">Necklaces</Link></li>
          <li><Link to="/shop?category=Earrings" className="hover:text-[#f3e5ab] transition-colors" data-testid="footer-link-earrings">Earrings</Link></li>
          <li><Link to="/shop?category=Rings" className="hover:text-[#f3e5ab] transition-colors" data-testid="footer-link-rings">Rings</Link></li>
          <li><Link to="/shop?category=Bracelets" className="hover:text-[#f3e5ab] transition-colors" data-testid="footer-link-bracelets">Bracelets</Link></li>
        </ul>
      </div>

      <div>
        <p className="eyebrow mb-5">Assurance</p>
        <ul className="space-y-3 text-sm text-zinc-400">
          <li>Anti-tarnish plating</li>
          <li>Skin-safe, nickel-free finish</li>
          <li>Dispatch in 48 hours</li>
          <li>7-day easy returns</li>
          <li><Link to="/track" className="hover:text-[#f3e5ab] transition-colors" data-testid="footer-link-track">Track Your Order</Link></li>
          <li><Link to="/admin" className="text-zinc-600 hover:text-[#8a7322] transition-colors text-xs" data-testid="footer-link-admin">Store Admin</Link></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-[#d4af37]/10 py-6">
      <p className="max-w-7xl mx-auto px-5 md:px-8 text-xs text-zinc-600 tracking-wide">
        © {new Date().getFullYear()} Jwellary. All pieces are imitation jewellery crafted in brass with gold plating.
      </p>
    </div>
  </footer>
);

export default Footer;
